import { render, staticRenderFns } from "./SubBottomBar.vue?vue&type=template&id=823380e8&scoped=true&"
import script from "./SubBottomBar.vue?vue&type=script&lang=js&"
export * from "./SubBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./SubBottomBar.vue?vue&type=style&index=0&id=823380e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823380e8",
  null
  
)

export default component.exports